import { render, staticRenderFns } from "./UsuariosIndex.vue?vue&type=template&id=6d3c22f0&"
import script from "./UsuariosIndex.vue?vue&type=script&lang=js&"
export * from "./UsuariosIndex.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports